// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"615":"ebcfc06e","8568":"953820b2"}[chunkId] + ".chunk.css";
};